<script>
import Base from "@/components/RequestDetails/FundCalc.vue";

export default {
  name: "CustomerServiceFundCalc",
  extends: Base,
};
</script>

